(function () {
	"use strict";

	function init() {
		var ctaBlock = document.querySelector(".cta-sticky-block");

		if (!ctaBlock) {
			return;
		}

		var footer = document.querySelector("footer");
		var scrollThreshold =
			parseInt(ctaBlock.getAttribute("data-scroll-threshold")) || 300;
		var isVisible = false;

		function checkScroll() {
			var scrollY = window.pageYOffset || document.documentElement.scrollTop;
			var shouldBeVisible = scrollY > scrollThreshold;

			// Check if footer is in viewport
			if (footer && shouldBeVisible) {
				var footerRect = footer.getBoundingClientRect();
				var windowHeight = window.innerHeight;

				// Hide CTA if footer is visible in viewport
				if (footerRect.top < windowHeight) {
					shouldBeVisible = false;
				}
			}

			if (shouldBeVisible && !isVisible) {
				ctaBlock.classList.add("is-visible");
				isVisible = true;
			} else if (!shouldBeVisible && isVisible) {
				ctaBlock.classList.remove("is-visible");
				isVisible = false;
			}
		}

		window.addEventListener("scroll", checkScroll);
		checkScroll();
	}

	// Wait for DOM to be ready
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		// DOM is already ready
		init();
	}
})();
